import { findControls, sliderThumbs } from "@plugins";

const questionsSlider = document.querySelector(".js-questions-slider-init");

if (questionsSlider) {
    const questionsSliderContainer = questionsSlider.querySelector(
        ".js-questions-slider-container",
    );
    const questionsSliderControls = findControls(questionsSlider, ".js-questions-slider-controls");

    sliderThumbs(questionsSlider, questionsSliderContainer, questionsSliderControls);
}
